import React from "react";
import { Link } from "react-router-dom";
import logoIcon from "../assets/matrixos/logo-icon.png";

const linkClass = "text-sm font-medium text-slate-200 transition hover:text-cyan-300";

export default function SiteHeader({ active = "" }) {
  const isActive = (value) => active === value;

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/8 bg-[#050d18]/72 backdrop-blur-2xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-4">
        <Link to="/" className="flex items-center gap-3">
          <img src={logoIcon} alt="MATRIXOS" className="h-11 w-11 object-contain drop-shadow-[0_0_18px_rgba(34,211,238,.24)]" />
          <div>
            <div className="text-xl font-black tracking-[0.18em] text-white">MATRIXOS</div>
            <div className="text-[11px] uppercase tracking-[0.35em] text-cyan-200/80">powered by neo</div>
          </div>
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          <Link to="/neo" className={`${linkClass} ${isActive("neo") ? "text-cyan-300" : ""}`}>Neo</Link>
          <Link to="/morphius-count" className={`${linkClass} ${isActive("morphius") ? "text-cyan-300" : ""}`}>Morphius Count</Link>
          <a href="/#modes" className={`${linkClass} ${isActive("modes") ? "text-cyan-300" : ""}`}>Industry Modes</a>
          <Link to="/contact" className={`${linkClass} ${isActive("contact") ? "text-cyan-300" : ""}`}>Contact</Link>
          <Link to="/faq" className={`${linkClass} ${isActive("faq") ? "text-cyan-300" : ""}`}>FAQ</Link>
          <Link to="/book-demo" className="rounded-full border border-cyan-300/40 px-5 py-2 text-sm font-semibold text-white transition hover:bg-cyan-400/10">
            Book Demo
          </Link>
          <Link to="/login" className="rounded-full bg-cyan-400 px-5 py-2 text-sm font-bold text-slate-950 transition hover:bg-cyan-300">
            Sign In
          </Link>
        </nav>
      </div>
    </header>
  );
}
